"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/es.string.link.js");

require("core-js/modules/web.timers.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _link = require("@meepshop/link");

var _withHook = _interopRequireDefault(require("@store/utils/lib/withHook"));

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _propTypes2 = require("../constants/propTypes");

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("./styles/index.less");

var styles = {
  "link": "meepshop-meep-ui__link-index__link"
};
var Link = (_dec = (0, _withHook["default"])(function () {
  return {
    router: (0, _link.useRouter)()
  };
}), _dec(_class = (0, _DecoratorsRoot.enhancer)(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Link, _React$PureComponent);

  var _super = _createSuper(Link);

  function Link() {
    var _this;

    (0, _classCallCheck2["default"])(this, Link);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClick", function (url) {
      return function (e) {
        // return when clicking with these following key
        if (e.shiftKey || e.metaKey || e.ctrlKey) return;
        var _this$props = _this.props,
            target = _this$props.target,
            router = _this$props.router;

        var _URL = new _urlParse["default"](/^#/.test(url) ? "".concat(window.location.pathname).concat(window.location.search).concat(url) : url),
            host = _URL.host,
            pathname = _URL.pathname,
            query = _URL.query,
            hash = _URL.hash;

        if (target === '_blank' || host !== window.location.host || /^tel:+/.test(url)) return;
        e.preventDefault();
        router.push({
          pathname: pathname === '' ? '/' : pathname,
          search: query,
          hash: hash
        });
        setTimeout(function () {
          if (hash) {
            var dom = document.querySelector(hash);
            dom.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }, 500);
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(Link, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.href,
          target = _this$props2.target,
          children = _this$props2.children,
          className = _this$props2.className;
      var url = !href || /(^#)|(^\/)|(^http)|(^tel:+)/.test(href) ? href : "//".concat(href);
      if (!url) return /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(styles.link, " ").concat(className)
      }, children);
      return /*#__PURE__*/_react["default"].createElement("a", {
        "data-testid": url,
        className: "".concat(styles.link, " ").concat(className),
        href: url,
        target: target,
        onClick: this.onClick(url)
      }, children);
    }
  }]);
  return Link;
}(_react["default"].PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** props */
  href: _propTypes["default"].oneOfType([_propTypes2.URL_TYPE, _propTypes2.HASH_TYPE]),
  target: _propTypes["default"].oneOf(['_self', '_blank', '_parent', '_top']),

  /** ignore */
  className: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]).isRequired
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  /** props */
  href: null,
  target: '_self',

  /** ignore */
  className: ''
}), _temp)) || _class) || _class);
exports["default"] = Link;